import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'truncate',
  pure: false
})
@Injectable()
export class TruncatePipe implements PipeTransform {
  transform(s: string, arglen?: number, argboundry?: boolean): any {
    let len = 42;
    let useWordBoundary = false;
    if (arglen) {
      len = arglen;
    }
    if (argboundry) {
      useWordBoundary = argboundry;
    }
    if (!s) {
      return s;
    }
    const isTooLong = s.length > len;
    let s_ = isTooLong ? s.substr(0, len) : s;
    s_ = (useWordBoundary && isTooLong) ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
    return isTooLong ? s_ + '...' : s_;
  }
}

